

<template>
  <a-layout>
    <a-layout-content class="performance-list" :style="{ margin: '24px 16px', padding: '24px', background: '#fff'}">
      <div class="performance-list-header">PT费明细表</div>
      <div class="project-info-list-search performance-list-search-project-statistic">
        <a-select placeholder="项目" @change="changeProjectSN" v-model="project_sn" class="project_sn" v-if="projectSnList.length>0" showSearch :filterOption="selectFilterOption">
          <a-select-option :value="item.val" v-for="(item,index) in projectSnList" :key="index">{{item.val}}</a-select-option>
        </a-select>
        <a-range-picker v-model="months" :mode="['month','month']" format="YYYY-MM" valueFormat="YYYY-MM" @panelChange="handlePanelChange">
          <a-icon slot="suffixIcon" :component="'SvgIcDate'" />
        </a-range-picker>
        <a-select placeholder="开票状态" v-model="invoicedStatus" :allowClear="true" class="payStatus">
          <a-select-option :value="item.key" v-for="(item,index) in invoicedStatusList" :key="index">{{item.val}}</a-select-option>
        </a-select>
        <a-select placeholder="供应商回票状态" v-model="invoiceTrackStatus" :allowClear="true" class="payStatus">
          <a-select-option :value="item.key" v-for="(item,index) in invoiceTrackStatusList" :key="index">{{item.val}}</a-select-option>
        </a-select>
        <a-select placeholder="结算版本" v-model="settleNumber" :allowClear="true" class="payStatus" showSearch :filterOption="selectFilterOption">
          <a-select-option :value="item" v-for="(item,index) in settleList" :key="index">{{item}}</a-select-option>
        </a-select>

        <a-select placeholder="申请人" v-model="applier" :allowClear="true" showSearch :filterOption="selectFilterOption">
          <a-select-option :value="item.id" v-for="(item) in applierList" :key="item.id">{{item.name}}</a-select-option>
        </a-select>

        <a-select
          style="width: 360px;"
          placeholder="申请单号"
          v-model="applyNumber"
          showSearch
          @search="handleSearchApplyNumber"
          @change="handleChangeApplyNumber"
          :allowClear="true"
          :filterOption="selectFilterOption">
          <a-select-option :value="item.id" v-for="(item) in applyNumberList" :key="item.id">{{item.name}}</a-select-option>
        </a-select>

        <a-select placeholder="付款类型"  v-model="applyType" :allowClear="true" showSearch :filterOption="selectFilterOption">
          <a-select-option :value="item.id" v-for="(item) in applyTypeList" :key="item.id">{{item.name}}</a-select-option>
        </a-select>

        <a-button type="primary" :disabled="!project_sn || isEdit" @click="query">查询</a-button>
      </div>
      <div class="performance-list-search performance-list-search-project-statistic" style="margin-top: 10px; margin-bottom: 10px;">
        <a-button type="primary" :disabled="canCreate" @click="createVersion">新建结算版本</a-button>
        <a-button
        type="primary"
        :disabled="detailData.hasSettle !== 1 || dataSource.length <= 0"
         @click="editVersion">编辑结算版本</a-button>
        <a-button type="primary" :disabled="!(isEdit && originSelList.length > 0)" @click="saveVersion" :loading="getSelLoad">保存结算版本</a-button>
        <a-button type="primary" :disabled="detailData.hasSettle !== 1 || isEdit" :loading="versionLoading" @click="exportVersion">导出结算版本</a-button>
        <a-button v-if="$lkAdmin.checkRole('api.resource.ptFeeDetail.settle.confirm ::*')" type="primary" :disabled="detailData.hasSettle !== 1 || isEdit" @click="bill">结算版本确认开票</a-button>
        <a-button type="primary" :disabled="!project_sn || isEdit" @click="exportSearchResult" :loading="exportLoading">导出筛选结果</a-button>
        <a-button type="primary" :disabled="!project_sn || isEdit" @click="addPTDetail">新增PT费明细</a-button>
        <p>SMO费用、EDC费用、加班补助、银行手续费在这里添加</p>
      </div>
      <div class="header">
        <span class="tip" style="color: #1890ff;">{{`已勾选的结算金额为：${detailData.settleAmount || '0'}元，未勾选结算金额为：${detailData.unsettledAmount || '0'}元。（不含PT费报价税率）`}}</span>
      </div>
      <div class="header">
        <span class="tip">共有{{pagination.total}}条记录</span>
      </div>
      <a-table class="erp-project-list"
      :rowKey="record => record.id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination" :loading="loading"
      :scroll="{x:2210, y:tableScrollY}"
      @change='onChangeHandleTable'
      :row-selection="isEdit ? {hideSelectAll: true, selectedRowKeys: selectedRowKeys, getCheckboxProps: getCheckboxProps, onChange: onSelectChange, onSelect: onSelect, onSelectAll:onRowSelectAll} : emptySelect">
      <!-- 操作 -->
        <template slot="operation" slot-scope="text,record">
            <span style="color:#1890ff;cursor:pointer;" @click="lookSettlement(record)">查看</span>
            <span v-if="record.settleType !== '定额' && record.settleType !== '实报实销' && record.invoicedStatus == 0"> | </span>
            <span v-if="record.settleType !== '定额' && record.settleType !== '实报实销' && record.invoicedStatus == 0" style="color:#1890ff;cursor:pointer;" @click="editSettlement(record)">编辑</span>
            <span v-if="record.settleType === '定额' && record.invoicedStatus == 0"> | </span>
            <span v-if="record.settleType === '定额' && record.invoicedStatus == 0" style="color:#1890ff;cursor:pointer;" @click="perfect(record)">完善PT费信息</span>
        </template>
        <!-- 未结算说明 -->
        <template slot="settlement" slot-scope="text,record">
          <span style="color:#1890ff;cursor:pointer;" @click="lookComment(record)">{{ record.explains }}</span>
          <span v-if="record.invoicedStatus == 0" > | </span>
          <span v-if="record.invoicedStatus == 0" style="color:#1890ff;cursor:pointer;" @click="lookComment(record)">编辑</span>
        </template>
      </a-table>
      <AddPTDetailModal
      v-if="showAddModel"
      :formData="ptFormData"
      :fileList="fileList"
      :loadedFileKeys="loadedFileKeys"
      :visible="showAddModel"
      :isEdit="canEdit"
      :isNew="isNew"
      @cancel="addCancel"
      @refresh="fetchData">

      </AddPTDetailModal>
      <RewritePTDetailModal
      v-if="showPerfectModal"
      :visible="showPerfectModal"
      :formData="perfectData"
      :fileList="perfectFileList"
      :loadedFileKeys="perfectFileKeys"
      @cancel="perfectCancel"
      @refresh="fetchData">
      </RewritePTDetailModal>
    <CancelModal
    :visible="showCancelAlert"
    :list="cancelList"
    @cancel="handleAlertCancel"
    @submit="handleAlertSubmit">

    </CancelModal>
    </a-layout-content>
  </a-layout>
</template>

<script>
import moment from 'moment';
import {
  projectAuthorized,
} from '../../services/TimesheetStatisticalService.js';
import ProjectManageService from '../../services/ProjectManageService';
import AddPTDetailModal from './AddPTDetailModal.vue';
import RewritePTDetailModal from './RewritePTDetailModal.vue';
import CancelModal from './CancelModal.vue';
import { downloadFile } from '../../utils/tools';

import SvgIcDate from '../../assets/svg/ic-date-o.svg';

export default {
  components: {
    SvgIcDate,
    AddPTDetailModal,
    RewritePTDetailModal,
    CancelModal,
  },
  computed: {
    paramsObj() {
      return {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        projectSn: this.project_sn,
        dateBegin: this.dateBegin,
        dateEnd: this.dateEnd,
        invoicedStatus: this.invoicedStatus,
        invoiceTrackStatus: this.invoiceTrackStatus,
        settleNumber: this.settleNumber,
        applier: this.applier,
        applyNumber: this.applyNumber,
        applyType: this.applyType,
      };
    },
    canCreate() {
      return !(this.detailData.hasSettle === 0 && this.detailData.hasUnsettled === 1 && this.dataSource.length > 0 && this.detailData.hasApproved === 1);
    },
    showPerfect(record) {
      return record.settleType === '定额';
    },
    showLookAndEdit(record) {
      return record.settleType !== '定额' && record.settleType !== '实报实销';
    },

  },
  data() {
    return {
      getSelLoad: false,
      originSelList: [],
      cancelList: [], // 弹框展示
      showCancelAlert: false,
      showPerfectModal: false,
      isNew: false,
      canEdit: false,
      exportLoading: false,
      versionLoading: false,
      showAddModel: false,
      isEdit: false,
      emptySelect: null,
      selectedRowKeys: [],
      monthFormat: 'YYYY/MM/DD',
      project_sn: '',
      months: undefined,
      tableScrollY: 400,
      columns: [
        {
          title: '全选',
          dataIndex: 'fileName',
          key: 'fileName',
          width: 40,
        },
        {
          title: '统计年月',
          dataIndex: 'date',
          key: 'date',
          width: 200,
        },
        {
          title: '项目编号',
          dataIndex: 'projectSn',
          key: 'projectSn',
          width: 200,
        },
        {
          title: 'OA申请单号',
          dataIndex: 'oaNumber',
          key: 'oaNumber',
          width: 200,
        },
        {
          title: '申请人',
          dataIndex: 'applicant',
          key: 'applicant',
          width: 200,
        },
        {
          title: '收款方',
          dataIndex: 'payee',
          key: 'payee',
          width: 200,
        },
        {
          title: '付款类型',
          dataIndex: 'paymentType',
          key: 'paymentType',
          width: 200,
        },
        {
          title: '预算科目',
          dataIndex: 'budgetSubject',
          key: 'budgetSubject',
          width: 200,
        },
        {
          title: '金额（元）',
          dataIndex: 'oaAmount',
          key: 'createTime',
          width: 200,
        },
        {
          title: '供应商回票状态',
          dataIndex: 'invoiceTrackStatusName',
          key: 'invoiceTrackStatusName',
          width: 200,
        },
        {
          title: '发票日期',
          dataIndex: 'invoiceDate',
          key: 'invoiceDate',
          width: 200,
        },
        {
          title: '未回票金额',
          dataIndex: 'invoiceOweAmount',
          key: 'invoiceOweAmount',
          width: 200,
        },
        {
          title: '业务目的',
          dataIndex: 'purpose',
          key: 'purpose',
          width: 200,
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
          width: 200,
        },
        {
          title: 'PT费结算金额(含税)',
          dataIndex: 'settleAmount',
          key: 'settleAmount',
          width: 200,
        },
        {
          title: '结算类型',
          dataIndex: 'settleType',
          key: 'settleType',
          width: 200,
        },
        {
          title: '结算版本',
          dataIndex: 'settleNumber',
          key: 'settleNumber',
          width: 200,
        },
        {
          title: '开票状态',
          dataIndex: 'invoicedStatusName',
          key: 'invoicedStatusName',
          width: 200,
          scopedSlots: { customRender: 'time' }
        },
        {
          title: '未结算说明',
          dataIndex: 'explains',
          key: 'explains',
          width: 200,
          scopedSlots: { customRender: 'settlement' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ],
      loading: false,
      projectSnList: [],
      applierList: [],
      applyNumberList: [],
      applyTypeList: [],
      invoiceTrackStatusList: [
        { key: 1, val: '未追踪' },
        { key: 2, val: '部分回票' },
        { key: 3, val: '发票已回' },
      ],
      invoiceTrackStatus: undefined, // 汇票状态
      invoicedStatusList: [
        { key: 0, val: '未开票' },
        { key: 1, val: '已开票' },
      ],
      invoicedStatus: undefined, // 开票状态
      dataSource: [],
      settleList: [],
      settleNumber: undefined, // 结算版本
      applier: undefined, // 申请人
      applyNumber: undefined, // 申请单号
      applyType: undefined, // 付款类型

      pagination: {
        defaultCurrent: 1,
        defaultPageSize: 10,
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
      },
      tagList: [],
      currentTag: 2,
      dateBegin: '',
      dateEnd: '',
      detailData: {},
      ptFormData: {
        date: undefined, // 日期
        applicant: undefined, // 申请人
        payee: undefined, // 收款方
        paymentId: undefined, // 付款类别
        oaAmount: undefined, // 结算金额
        purpose: undefined, // 业务目的
        remark: undefined, // 备注
        invoiceDate: undefined, // 发票日期
        file_list: [],
        paymentType: '',
      },
      perfectData: {
        paymentType: undefined, // 付款类型
        settleType: undefined, // 结算类型
        id: undefined,
        price: undefined, // 单价
        date: undefined, // 日期
        applicant: undefined, // 申请人
        payee: undefined, // 收款方
        paymentId: undefined, // 付款类别
        num: undefined, // 数量
        oaAmount: undefined, // 结算金额
        purpose: undefined, // 业务目的
        remark: undefined, // 备注
        invoiceTrackStatus: undefined, // 供应商汇票日期
        invoiceDate: undefined, // 发票日期
        file_list: [],
      },
      fileList: [],
      loadedFileKeys: [],
      perfectFileList: [],
      perfectFileKeys: [],
    };
  },
  created() {
    this.tableScrollY = document.documentElement.clientHeight - 320;
    const vm = this;
    window.onresize = function () {
      vm.tableScrollY = document.documentElement.clientHeight - 320;
      const dom1 = document.getElementsByClassName('ant-table-body');
      const dom2 = document.getElementsByClassName('ant-table-body-inner');
      if (dom1) {
        for (let i = 0; i < dom1.length; i++) {
          dom1[i].style.maxHeight = `${vm.tableScrollY}px`;
        }
      }
      if (dom2) {
        for (let i = 0; i < dom2.length; i++) {
          dom2[i].style.maxHeight = `${vm.tableScrollY}px`;
        }
      }
    };
    this.init();
  },
  methods: {
    moment,
    download(record) {
      ProjectManageService.getProjectFileUrl({ id: record.id }).then((res) => {
        if (res.status === 'success') {
          window.open(res.data, '_blank');
        }
      });
    },
    handleSearchApplyNumber(value) {
      console.log('value: ', value);
      this.getApplyNumberList(value);
    },
    handleChangeApplyNumber(value) {
      // console.log('change value: ', value);
      // this.getApplyNumberList(value);
    },
    selectFilterOption(input, option) {
      return option.componentOptions.children[0].text.includes(input);
    },
    disabledDate(current) {
      return (
        current
        && (current > moment().endOf('day') || current < moment('20190501'))
      );
    },
    onChangeDate(date) {
      this.month = moment(date);
    },
    init() {
      ProjectManageService.getPTTotalProjectOption({ reportType: 2 }).then((res) => {
        if (res.status === 'success') {
          this.projectSnList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });

      this.getApplyNumberList();

      ProjectManageService.getPTDetailApplyTypesOption({
      }).then((res) => {
        if (res.status === 'success') {
          this.applyTypeList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    changeProjectSN() {
      this.getSettleList();
      this.getApplierList();
    },
    getApplyNumberList(keyword = null) {
      ProjectManageService.getPTDetailApplyOption({
        keyword,
      }).then((res) => {
        if (res.status === 'success') {
          this.applyNumberList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getApplierList() {
      ProjectManageService.getPTTotalStaffOption({
        projectSn: this.project_sn,
      }).then((res) => {
        if (res.status === 'success') {
          this.applierList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getSettleList() {
      if (!this.project_sn) return;
      this.clear();
      this.getPTDetail();
      ProjectManageService.getSettleList({ projectSn: this.project_sn }).then((res) => {
        if (res.status === 'success') {
          this.settleList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      pager.pageSize = pagination.pageSize;
      this.pagination = pager;
      this.fetchData();
    },
    onChangeHandleTable(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.fetchData();
    },
    query() {
      this.pagination.current = 1;
      this.fetchData();
    },
    clear() {
      this.isEdit = false;
      this.selectedRowKeys = [];
      this.detailData = {};
      this.dataSource = [];
      this.settleList = [];
      this.dateBegin = undefined;
      this.dateEnd = undefined;
      this.months = [];
      this.invoicedStatus = undefined;
      this.invoiceTrackStatus = undefined;
      this.settleNumber = undefined;
      this.applyNumber = undefined;
      this.applyType = undefined;
      this.applier = undefined;
      this.clearEditList();
    },
    createVersion() {
      this.isEdit = !this.isEdit;
      if (this.isEdit) {
        this.resetSelectedRowKeys();
        this.dataSource.forEach((item) => {
          if (item.settleStatus === 1 && this.originSelList.indexOf(item.id) < 0) {
            this.originSelList.push(item.id);
          }
        });
      } else {
        this.clearEditList();
      }
    },
    editVersion() {
      this.isEdit = !this.isEdit;
      if (this.isEdit) {
        this.resetSelectedRowKeys();
        this.getSelectedList();
      } else {
        this.clearEditList();
      }
    },
    saveVersion() {
      this.isEdit = false;
      ProjectManageService.saveSettleVersion({ projectSn: this.project_sn, idList: this.originSelList }).then((res) => {
        if (res.status !== 'success') {
          this.$Message.error(res.message);
        } else {
          this.$Message.success('保存成功');
        }
        this.clearEditList();
        this.fetchData();
      });
    },
    clearEditList() {
      this.selectedRowKeys = [];
      this.originSelList = [];
    },
    resetSelectedRowKeys() {
      this.selectedRowKeys = [];
      this.dataSource.forEach((item) => {
        if (item.settleStatus === 1) {
          this.selectedRowKeys.push(
            item.id
          );
        }
      });
    },
    exportVersion() {
      this.isEdit = false;
      const tempProject = encodeURIComponent(this.project_sn);
      const resource_link = `/rws/api/resource/ptFeeDetail/exportSettle?projectSn=${tempProject}`;
      const url = `${window.location.origin}${resource_link}`;
      downloadFile(url);
      this.versionLoading = true;
      const timeId = setTimeout(() => {
        this.versionLoading = false;
        clearTimeout(timeId);
      }, 2000);
    },
    bill() {
      this.isEdit = false;
      ProjectManageService.settleConfirm({ projectSn: this.project_sn, }).then((res) => {
        if (res.status !== 'success') {
          this.$Message.error(res.message);
        } else {
          this.$Message.success('保存成功');
        }
        this.fetchData();
      });
    },
    exportSearchResult() {
      this.isEdit = false;
      const tempProject = encodeURIComponent(this.project_sn);
      const resource_link = `/rws/api/resource/ptFeeDetail/exportSearch?projectSn=${tempProject}`
        + `&dateBegin=${this.dateBegin || ''}`
        + `&dateEnd=${this.dateEnd || ''}`
        + `&invoicedStatus=${this.invoicedStatus || ''}`
        + `&invoiceTrackStatus=${this.invoiceTrackStatus || ''}`
        + `&settleNumber=${this.settleNumber || ''}`
        + `&applier=${this.applier || ''}`
        + `&applyNumber=${this.applyNumber || ''}`
        + `&applyType=${this.applyType || ''}`;

      const url = `${window.location.origin}${resource_link}`;
      console.log('导出筛选接口', resource_link);
      downloadFile(url);
      this.exportLoading = true;
      const timeId = setTimeout(() => {
        this.exportLoading = false;
        clearTimeout(timeId);
      }, 2000);
    },
    addCancel() {
      this.showAddModel = false;
      this.clearEditList();
    },
    addPTDetail() {
      this.ptFormData = {
        date: undefined, // 日期
        applicant: undefined, // 申请人
        payee: undefined, // 收款方
        paymentId: undefined, // 付款类别
        oaAmount: undefined, // 结算金额
        purpose: undefined, // 业务目的
        remark: undefined, // 备注
        invoiceDate: undefined, // 发票日期
        file_list: [],
        invoiceTrackStatus: undefined,
        projectSn: this.project_sn,
        paymentType: '',
      };
      this.loadedFileKeys = [];
      this.fileList = [];
      this.showAddModel = true;
      this.canEdit = true;
      this.isNew = true;
    },
    handleCancel() {
      this.showAddModel = false;
    },
    handleOk() {
      this.showAddModel = false;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.$set(this, 'selectedRowKeys', selectedRowKeys);
    },
    onSelect(record, selected, selectedRows, nativeEvent) {
      if (selected) {
        this.originSelList.push(record.id);
      } else {
        this.cancelList.push(record);
        if (this.originSelList.indexOf(record.id) >= 0) {
          this.originSelList.splice(this.originSelList.indexOf(record.id), 1);
        }
        this.showCancelAlert = true;
      }
    },
    onRowSelectAll(selected, selectedRows, changeRows) {
      this.dataSource.forEach((item) => {
        if (selected) {
          if (this.originSelList.indexOf(item.id) < 0 && item.selectEnable !== 0) {
            this.originSelList.push(item.id);
          }
        } else {
          if (item.selectEnable !== 0) {
            this.cancelList.push(item);
          }
          if (this.originSelList.indexOf(item.id) >= 0 && item.selectEnable !== 0) {
            this.originSelList.splice(this.originSelList.indexOf(item.id), 1);
          }
          this.showCancelAlert = true;
        }
      });
    },
    handleAlertCancel() {
      this.showCancelAlert = false;
      this.cancelList.forEach((item) => {
        if (this.originSelList.indexOf(item.id) < 0) {
          this.originSelList.push(
            item.id
          );
        }
        if (this.selectedRowKeys.indexOf(item.id) < 0) {
          this.selectedRowKeys.push(
            item.id
          );
        }
      });
      this.cancelList = [];
    },
    handleAlertSubmit() {
      this.showCancelAlert = false;
      this.cancelList = [];
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled:
            record.selectEnable === 0
        }
      };
    },
    editSettlement(record) {
      this.canEdit = true;
      this.showPTDetail(record);
    },
    lookSettlement(record) {
      this.canEdit = false;
      this.showPTDetail(record);
    },
    showPTDetail(record) {
      this.ptFormData = [];
      const { date, applicant, payee, paymentId, oaAmount, purpose, remark, invoiceDate, file_list, invoiceTrackStatus, id, paymentType } =  _.cloneDeep(record);
      this.fileList = [];
      if (file_list) {
        file_list.forEach((item) => {
          this.fileList.push({ file_key: item.file_key, uid: item.file_key, name: item.file_name });
        });
      }
      this.loadedFileKeys = _.cloneDeep(file_list);
      this.ptFormData = {
        id,
        date,
        applicant,
        payee,
        paymentId,
        oaAmount,
        purpose,
        remark,
        invoiceDate,
        file_list,
        projectSn: this.project_sn,
        paymentType,
        invoiceTrackStatus: invoiceTrackStatus === 0 ? undefined : invoiceTrackStatus
      };
      this.showAddModel = true;
      this.isNew = false;
    },
    handlePanelChange(value) {
      this.months = value;
      this.dateBegin = moment(value[0]).format('YYYY-MM');
      this.dateEnd = moment(value[1]).format('YYYY-MM');
    },
    perfect(data) {
      const record = _.cloneDeep(data);
      record.file_list = record.file_list || [];
      record.invoiceTrackStatus = record.invoiceTrackStatus === 0 ? undefined : record.invoiceTrackStatus;
      this.perfectData = record;
      this.perfectFileList = [];
      if (record.file_list) {
        record.file_list.forEach((item) => {
          this.perfectFileList.push({ file_key: item.file_key, uid: item.file_key, name: item.file_name, file_name: item.file_name });
        });
      }
      this.perfectFileKeys = _.cloneDeep(this.perfectFileList);
      this.showPerfectModal = true;
    },
    perfectCancel() {
      this.showPerfectModal = false;
    },
    lookComment(record) {
      const canEdit = record.invoicedStatus === 0;
      const url = `${window.location.origin}/rws/projectManage/pTNoSettlement/${record.id}/${canEdit}`;
      window.open(url, '_blank');
    },
    resetLocalList() {
      // this.selectedRowKeys.forEach((item) => {
      //   if (this.localSelList.indexOf(item) < 0) {
      //     this.localSelList.push(item);
      //   }
      // });
    },
    fetchData() {
      this.getPTDetail();
      this.loading = true;
      // 如果之前有选择，需要默认选择选择
      this.selectedRowKeys = [];
      ProjectManageService.getPTDetailList(this.paramsObj).then((res) => {
        if (res.status === 'success') {
          this.dataSource = res.data.list;
          this.pagination.total = res.data.total;
          this.loading = false;
        } else {
          this.dataSource = [];
          this.loading = false;
          this.$Message.error(res.message);
        }
        this.dataSource.forEach((item) => { // 编辑状态下，点击分页
          if (item.settleStatus === 1) {
            if (this.selectedRowKeys.indexOf(item.id) < 0 && this.originSelList.indexOf(item.id) >= 0) {
              this.selectedRowKeys.push(item.id);
            }
          } else {
            if (this.originSelList.indexOf(item.id) >= 0) {
              this.selectedRowKeys.push(item.id);
            }
          }
        });
      });
    },
    getPTDetail() { // 头部总数据
      ProjectManageService.getPTDetail({ projectSn: this.project_sn }).then((res) => {
        if (res.status === 'success') {
          this.detailData = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getSelectedList() { // 获取已经选择的列表
      this.getSelLoad = true;
      ProjectManageService.getSelectedSettleList({ projectSn: this.project_sn }).then((res) => {
        this.getSelLoad = false;
        if (res.status === 'success') {
          this.originSelList = res.data;
          this.dataSource.forEach((item) => { // 点击编辑
            if (item.settleStatus === 1) {
              // 更新table的数组
              if (this.selectedRowKeys.indexOf(item.id) < 0 && this.originSelList.indexOf(item.id) >= 0) {
                this.selectedRowKeys.push(
                  item.id
                );
              }
            }
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
  }
};
</script>

<style lang="less">
.payStatus {
  width: 150px;
  margin-right: 16px !important;
}
.project-info-list-search {
  flex-wrap: wrap;
  display: flex;
  .ant-select {
    margin-bottom: 16px;
  }
  .ant-select-selection {
    height: 28px;
    min-width: 144px;
    line-height: 28px;
    margin-right: 24px;

    .ant-select-selection__rendered {
      height: 100%;
    }

    .ant-select-selection__placeholder {
      height: 28px;
      line-height: 28px;
      margin-top: -14px;
    }

    .ant-select-selection-selected-value {
      height: 26px;
      line-height: 26px;
    }
  }

  .ant-calendar-picker .ant-input {
    height: 28px;
    min-width: 144px;
  }

  .ant-calendar-picker {
    margin-right: 16px;
  }

  .ant-btn {
    margin-right: 8px;
    height: 28px;
    line-height: 28px;
  }
}
.erp-project-list {
    th[key="handle"] > div {
      padding-left: 16px;
    }
  }
</style>
